import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Modal, Spinner } from 'react-bootstrap';
import PositionForm from '../components/forms/PositionForm';
import '../styles/EmployeeMaster.css';
import PositionTable from '../components/PositionTable';

const PositionEditModel = () => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const navigate = useNavigate();
     const location = useLocation();
     const { id } = useParams(); // ✅ Get ID from route

     const [positionData, setPositionData] = useState(null);
     const [loading, setLoading] = useState(false);

     // ✅ Show modal only if URL starts with /sbu/edit
     const showModal = location.pathname.startsWith('/position/edit');

     const handleCloseModal = () => {
          navigate('/position'); // Go back to list
     };

     // ✅ Fetch SBU details by ID
     useEffect(() => {
          if (id && showModal) {
               setLoading(true);
               fetch(`${baseUrl}/getUserPositById/${id}`)
                    .then(res => res.json())
                    .then(data => {
                         if (data.status) {
                              setPositionData(data.data);
                         } else {
                              setPositionData(null);
                         }
                         setLoading(false);
                    })
                    .catch(err => {
                         console.error('Error fetching SBU by ID:', err);
                         setLoading(false);
                    });
          }
     }, [id, showModal, baseUrl]);

     return (
          <div className="employee-master-page">
               <div className="employee-header">
                    <h2>Position Master</h2>
               </div>

               {/* Table of SBUs */}
               <PositionTable />

               {/* Edit Modal */}
               <Modal show={showModal} onHide={handleCloseModal} size="md" centered>
                    <Modal.Header closeButton>
                         <Modal.Title>Edit Position</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                         {loading ? (
                              <div className="text-center">
                                   <Spinner animation="border" /> Loading...
                              </div>
                         ) : positionData ? (
                              <PositionForm positionId={id} initialData={positionData} /> // ✅ Pass data to form
                         ) : (
                              <p className="text-center">No data found for this SBU.</p>
                         )}
                    </Modal.Body>

               </Modal>
          </div>
     );
};

export default PositionEditModel;
